













































import { defineComponent } from "@vue/composition-api";
import AvailableContentCount from "@/components/AvailabelContentCount";
import BaseButton from "@/components/BaseButton";
import BaseCard from "@/components/BaseCard";
import BaseSpinner from "@/components/BaseSpinner/BaseSpinner.vue";
import FormatMoney from "@/components/FormatMoney/FormatMoney.vue";
import TextClamp from "@/components/TextClamp/TextClamp.vue";

export default defineComponent({
  name: "CardCost",
  components: { BaseCard, FormatMoney, TextClamp, BaseSpinner, BaseButton, AvailableContentCount },
  props: {
    buttonText: { type: String, required: true },
    description: { type: String },
    processing: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    isAvailable: { type: Boolean, default: false },
    isActive: { type: Boolean, default: false },
    gradient: { type: Boolean, default: false },
    hasGradient: { type: Boolean, default: false },
    deposit: { type: Boolean, default: false },
    cost: { type: Number, required: true },
    currencyCode: { type: String },
    contentCount: { type: Number },
  },
});
